import { compareValues } from "@sscs/utils";
export const NO_PREVALENCE_TEXT = "No behavior prevalence information at this time";
const PREVALENCE_TO_NUMBER = {
    "behavior-common": 0,
    "behavior-uncommon": 1,
    "behavior-anomalous": 2,
    "behavior-important": 3,
    "behavior-malicious": 4,
};
const getWorstPrevalence = (prevalence) => {
    if (!prevalence || prevalence.length === 0)
        return 0;
    const worstPrevalence = prevalence.reduce((worst, current) => PREVALENCE_TO_NUMBER[worst] > PREVALENCE_TO_NUMBER[current]
        ? worst
        : current, "behavior-common");
    return PREVALENCE_TO_NUMBER[worstPrevalence];
};
export const sortCommunitiesByPrevalence = (prevalence) => {
    return Object.keys(prevalence).sort((first, second) => {
        const firstWorstPrevalence = getWorstPrevalence(prevalence[first]);
        const secondWorstPrevalence = getWorstPrevalence(prevalence[second]);
        return compareValues(firstWorstPrevalence, secondWorstPrevalence, true);
    });
};
//# sourceMappingURL=utils.js.map